import { TextField } from '@mui/material';
import { DEFAULT_PROPS } from '../Constants';

export const OutputColumnField = ({
  type = 'text',
  value,
  onChange,
  error,
  disabled = DEFAULT_PROPS.disabled,
  label = 'Output Column *',
  helperText = 'Name for the resulting column',
}) => (
  <TextField
    fullWidth
    label={label}
    value={value}
    onChange={onChange}
    disabled={disabled}
    size="small"
    error={!!error}
    type={type}
    helperText={helperText}
  />
);
